import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../lib/shared/shared.module';

import { MapComponent } from './map.component';
import { MapServiceInterface } from './map-service-interface.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [MapComponent],
  exports: [
    MapComponent
  ],
})
export class MapModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: MapModule,
      providers: [
        MapServiceInterface
      ]
    };
  }
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/map/map.module.ts